import useLocalStorage from 'hooks/useLocalStorage';

export type CompanyViewModes = 'list' | 'grid';

export default function useViewMode() {
  const [viewMode, setViewMode] = useLocalStorage<CompanyViewModes>('company-view-mode', 'grid');
  return {
    viewMode,
    setViewMode,
  };
}
